<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA SEGURIDAD SOCIAL</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncSocialSecurity | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let socialSecurity">
                            <div class="action-buttons">
                                <a
                                    (click)="updateEducation(socialSecurity)"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(socialSecurity.id)"
                                    appOnlysuperuser="/social-security"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="personalData">
                        <th mat-header-cell *matHeaderCellDef>Usuario</th>
                        <td mat-cell *matCellDef="let socialSecurity">
                            {{ socialSecurity.outsider?.identificationType }}
                            {{ socialSecurity.outsider?.identificationCode }}
                            {{ socialSecurity.outsider?.name }}
                            {{ socialSecurity.outsider?.lastName }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="eps">
                        <th mat-header-cell *matHeaderCellDef>EPS</th>
                        <td mat-cell *matCellDef="let socialSecurity">
                            {{ socialSecurity.eps }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="hasInsurance">
                        <th mat-header-cell *matHeaderCellDef>Seguro</th>
                        <td mat-cell *matCellDef="let socialSecurity">
                            {{ socialSecurity.hasInsurance ? 'Sí' : 'No' }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="insuranceKind">
                        <th mat-header-cell *matHeaderCellDef>Régimen</th>
                        <td mat-cell *matCellDef="let socialSecurity">
                            {{ socialSecurity.insuranceKind }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchSocialSecurity($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
